<div class="container" fxLayout="row" fxLayoutAlign="center none">
    <div fxFlex="95%">
        <div class="container" fxLayout="column">
            <div fxLayout="row" fxLayoutGap="0.5vw" fxLayoutAlign="end end">
                <mat-icon style="cursor: pointer;" (click)="openOpeningActs()"
                    [title]="'Create Opening Act' | translate">
                    add_circle
                </mat-icon>
            </div>
            <div fxFlex class="no-records animate">
                <table mat-table [dataSource]="datasource" class="mat-elevation-z8 table" *ngIf="datasource">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef style="width: 20%;"> {{'Name' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                    </ng-container>
                    <ng-container matColumnDef="tools">
                        <th mat-header-cell *matHeaderCellDef style="width: 20%;"></th>
                        <td mat-cell *matCellDef="let element" class="tools">
                            <mat-icon (click)="editOpeningAct(element._id)" [title]="'Edit Opening Act' | translate">
                                edit</mat-icon>
                            <mat-icon (click)="deleteOpeningAct(element._id)"
                                [title]="'Delete Opening Act' | translate">delete
                            </mat-icon>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

                <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
                </mat-paginator>
            </div>
        </div>
    </div>
</div>